import React from 'react'
import {defineMessages, useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import {useGetIsOfferSoldOut} from 'hooks/useGetIsOfferSoldOut/useGetIsOfferSoldOut'
import {
  getIsCheapestRoomOfferByTotalPrice,
  getIsRoomOfferCheapestOverall
} from 'modules/searchApi/selectors'
import {
  getOfferTitleMessage,
  offerTitleMessages
} from 'utils/roomOfferTitle/offerTitleKeyMapping'

import {Text} from '@vio/atlas/Text'
import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {Offer} from '@vio/core/src/offer/types/offer'

interface Props {
  offer: Offer
}

const clientOverrideMessages = defineMessages({
  soldOut: {
    id: 'errors.soldoutTitle',
    defaultMessage: 'Sold out on {brandName}'
  },
  cheapestOffer: {
    id: 'roomOfferCardTitle.isCheapestOffer',
    defaultMessage: "Today's lowest price"
  }
})

export const RoomOfferCardTitle = ({offer}: Props) => {
  const {formatMessage} = useIntl()
  const {brandName} = useBrand()

  const isOfferSoldOut = useGetIsOfferSoldOut({offer})
  const isCheapestOffer = useSelector(state =>
    getIsCheapestRoomOfferByTotalPrice(state, offer.id)
  )

  const isRoomOfferCheapestOverall = useSelector(getIsRoomOfferCheapestOverall)

  // Show "Today's lowest price" only when this is the cheapest room offer AND
  // the room offer is cheaper than or equal to top offers
  const showCheapestOfferLabel = isCheapestOffer && isRoomOfferCheapestOverall

  const getMessage = () => {
    if (isOfferSoldOut) return clientOverrideMessages.soldOut
    if (showCheapestOfferLabel) return clientOverrideMessages.cheapestOffer
    return (
      getOfferTitleMessage(offer.offerTitleKey) ??
      offerTitleMessages.room_only_non_refundable
    )
  }

  const getColorPath = () => {
    if (isOfferSoldOut) return 'content.danger.secondary'
    if (showCheapestOfferLabel) return 'content.success.secondary'
    return 'content.neutral.primary'
  }

  return (
    <Text variant="titleM" colorPath={getColorPath()}>
      {formatMessage(getMessage(), {brandName})}
    </Text>
  )
}
